import styled from "styled-components"
import { Link } from "gatsby"

import { FONT } from "src/developers/constants"

export const Container = styled(Link)`
  display: flex;
  flex-direction: column;

  background-color: #fff;
  border: 2px solid #dee0e6;
  border-radius: 16px;

  text-decoration: none;
  transition: 0.3s;

  position: relative;

  width: 373px;
  height: 480px;

  :hover {
    box-shadow: 0px 6px 14px rgba(15, 21, 78, 0.24);
    border-color: #fff;
  }

  :active {
    box-shadow: 0px 6px 10px rgba(15, 21, 78, 0.32);
    border-color: #fff;
  }

  @media (max-width: 1278px) {
    width: 346px;
  }

  @media (max-width: 1199px) {
    width: 352px;

    :hover {
      box-shadow: none;
      border-color: #dee0e6;
    }
  }

  @media (max-width: 1150px) {
    width: 468px;
  }

  @media (max-width: 1023px) {
    width: 100%;
  }

  @media (max-width: 600px) {
    height: auto;
  }
`

export const Thumbnail = styled.div`
  background-image: url(${props => props.src});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  border-radius: 12px 12px 0 0;

  min-height: 216px;

  @media (max-width: 599px) {
    min-height: 160px;
  }
`

export const InfoBox = styled.div`
  padding: 12px;
  padding-bottom: 32px;
`

export const TextBox = styled.div`
  max-height: 176px;
  display: flex;
  flex-direction: column;

  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 6;
`

export const Title = styled.h3`
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: #001553;

  margin: 0;
  margin-bottom: 4px;
`

export const Introduction = styled.p`
  font-family: ${FONT.PRIMARY};
  font-weight: normal;
  font-size: 15px;
  line-height: 28px;
  color: #001553;
  margin: 0;
`

export const DetailsBox = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`

export const Details = styled.p`
  font-family: ${FONT.PRIMARY};
  font-weight: normal;
  font-size: 13px;
  line-height: 24px;
  color: #838da3;
  margin: 0;
`

export const Time = styled(Details)`
  position: absolute;
  bottom: 16px;
`

export const AuthorName = styled(Time)`
  line-height: 16px;
  width: calc(100% - 16px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`
